// components/RecentResourcesSection.js
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchWithAuth } from '../auth';
import ContentCard from './ContentCard';

export default function RecentResourcesSection() {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let ignore = false;
    const abortController = new AbortController();

    const fetchResults = async () => {
      setLoading(true);
      setError('');

      try {
        const res = await fetchWithAuth('/api/resources/recent/', {
          signal: abortController.signal,
        });

        if (!res.ok) {
          throw new Error('Failed to load recent resources');
        }

        const data = await res.json();
        if (!ignore) {
          setResults(data);
        }
      } catch (err) {
        if (err.name !== 'AbortError' && !ignore) {
          setError('שגיאה בטעינת משאבים חדשים');
        }
      } finally {
        if (!ignore) {
          setLoading(false);
        }
      }
    };

    fetchResults();

    return () => {
      ignore = true;
      abortController.abort();
    };
  }, []);

  const navigate = useNavigate();

  const handleCardClick = (item) => {
    if (item.url) {
      navigate(item.url);
    }
  };

  if (loading) {
    return (
      <div className="mb-12">
        <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-6">משאבים חדשים</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" style={{ display: 'grid' }}>
          {[...Array(6)].map((_, i) => (
            <div key={i} className="bg-white dark:bg-secondary-800 rounded-xl shadow-sm border border-gray-100 dark:border-secondary-700 p-5 animate-pulse">
              <div className="h-4 bg-gray-200 dark:bg-secondary-700 rounded w-1/3 mb-3"></div>
              <div className="h-6 bg-gray-200 dark:bg-secondary-700 rounded w-2/3 mb-2"></div>
              <div className="h-4 bg-gray-200 dark:bg-secondary-700 rounded w-full mb-2"></div>
              <div className="h-4 bg-gray-200 dark:bg-secondary-700 rounded w-3/4"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return null; // Hide section on error
  }

  if (results.length === 0) {
    return null; // Hide section if no results
  }

  return (
    <div className="mb-12">
      <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-6">משאבים חדשים</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" style={{ display: 'grid' }}>
        {results.slice(0, 6).map((item) => (
          <ContentCard
            key={`${item.model_type}-${item.id}`}
            item={item}
            onClick={() => handleCardClick(item)}
          />
        ))}
      </div>
    </div>
  );
}

